import { render, staticRenderFns } from "./RatingAdminNavigationDrawer.vue?vue&type=template&id=9494c0be"
import script from "./RatingAdminNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./RatingAdminNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports